import { useTranslation } from 'react-i18next';
import type { ObjectDiscussionMessageType } from '@econtractor/types';
import DiscussionMessage from './DiscussionMessage';
import { orderDiscussionMessages } from './model/discussionMessages';
import type { DiscussionSort } from './model/discussionSort';

interface DiscussionFeedProps {
    messages: ObjectDiscussionMessageType[];
    sort: DiscussionSort;
}

const DiscussionFeed = ({ messages, sort }: DiscussionFeedProps) => {
    const { t } = useTranslation(['Objects']);
    const ordered = orderDiscussionMessages(messages, sort);

    if (!messages.length) {
        return (
            <div className="object-discussion__feed object-discussion__feed--empty">
                <p className="text-muted mb-0">{t('discussion.empty')}</p>
            </div>
        );
    }

    return (
        <div className="object-discussion__feed">
            {ordered.map((message) => (
                <DiscussionMessage key={message.ID} message={message} />
            ))}
        </div>
    );
};

export default DiscussionFeed;
